import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { useTable, useGlobalFilter, usePagination } from 'react-table';
import { FaChevronLeft, FaChevronRight, FaAngleDoubleLeft, FaAngleDoubleRight, } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment,faTrash,faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import 'font-awesome/css/font-awesome.min.css';
import '../css/usermain.css';
import axios from 'axios';
import AddTaskPopup from './AddTaskPopup';
import SlideTask from './SlideTask';
import TaskTimerAction from './TaskTimerAction';
import EditTaskPopup from '../components/EditTaskPopup';

const UserTaskList = () => {
   const [taskData, setTaskData] = useState([]);
    const [filterInput, setFilterInput] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [activeTab, setActiveTab] = useState('singletask');
    const [showSidebar, setShowSidebar] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [projectNames, setProjectNames] = useState({});
     const [editTaskId, setEditTaskId] = useState(null);
      const [isEditOpen, setIsEditOpen] = useState(false);
            const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
      
    
      const handleEditClick = (taskId) => {
        setEditTaskId(taskId);
        setIsEditOpen(true);
      };
   
  
  
        useEffect(() => {
          fetch("/api/projectname.php?method=getNames")
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                setProjectNames(data.projects);
              }
            });
        }, []);
        const deleteTask = (id) => {
  if (window.confirm('Are you sure you want to delete this task?')) {
    axios.delete(`/api/tasks.php?id=${id}`)
      .then(() => {
        setTaskData(prev => prev.filter(task => task.id !== id));
        // Optional: show a success message
        // toast.success('Task deleted successfully');
      })
      .catch(err => {
        console.error('Error deleting task:', err);
        // Optional: show an error message
        // toast.error('Failed to delete task');
      });
  }
};
   
  
        const updateDuration = useCallback((taskId, newTimeObj) => {
          const task = taskData.find(t => t.id === taskId);
          let sessionArray = [];
        
          try {
            const parsed = JSON.parse(task?.duration || '[]');
            sessionArray = Array.isArray(parsed) ? parsed : [];
          } catch {
            sessionArray = [];
          }
  
          const lastSession = sessionArray[sessionArray.length - 1];
          let updatedSessions = [...sessionArray];
        
          // If trying to add a new "start"
          if (newTimeObj.start) {
            if (!lastSession || (lastSession.start && (lastSession.pause || lastSession.end))) {
              // Only add new start if no session or last session is finished
              updatedSessions.push({ start: newTimeObj.start });
            } else {
              console.warn("Cannot add new 'start': last session still running");
              return;
            }
          }
  
          else if (newTimeObj.pause || newTimeObj.end) {
            if (lastSession && lastSession.start && !lastSession.pause && !lastSession.end) {
              // Update the last active session with pause or end
              updatedSessions[updatedSessions.length - 1] = {
                ...lastSession,
                ...newTimeObj,
              };
            } else if (newTimeObj.pause && lastSession && lastSession.pause) {
              // If trying to pause again after a pause, treat it as new start
              updatedSessions.push({ start: newTimeObj.pause });
            } else {
              console.warn("Cannot add 'pause' or 'end': no active session with 'start'");
              return;
            }
          }
  
          // Save updated duration to DB
          fetch("/api/taskduration.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              method: "updateDuration",
              id: taskId,
              duration: JSON.stringify(updatedSessions),
            }),
          })
            .then(res => res.json())
            .then(response => {
              if (response.success) {
                console.log("Duration updated");
        
                // Update local state
                setTaskData(prev =>
                  prev.map(task =>
                    task.id === taskId ? { ...task, duration: JSON.stringify(updatedSessions) } : task
                  )
                );
              } else {
                console.error("Update failed:", response.message);
              }
            })
            .catch(error => console.error("Error updating duration:", error));
        }, [taskData]);
  
        const filteredTasks = useMemo(() => {
         const query = filterInput.toLowerCase().trim();
       
         // If search is active, include all tasks (even "done")
         if (query !== '') {
           return taskData.filter(task =>
             task.task_name.toLowerCase().includes(query) ||
             task.assign_to.toLowerCase().includes(query) ||
             task.assign_by?.toLowerCase().includes(query) ||
             task.client_name?.toLowerCase().includes(query) ||
             task.status?.toLowerCase().includes(query) ||
             task.priority?.toLowerCase().includes(query) ||
             task.start_date?.toLowerCase().includes(query) ||
             task.due_date?.toLowerCase().includes(query) ||
             task.project_id?.toLowerCase().includes(query)
           );
         }
       
         // If not searching, exclude "done" tasks
         return taskData.filter(task => task.status?.toLowerCase() !== 'done');
       }, [taskData, filterInput]);
  

  
  const filteredIndividualTasks = useMemo(() => {
    return filteredTasks.filter(task => !task.project_id || task.project_id.trim() === '');
  }, [filteredTasks]);
  
  const filteredProjectTasks = useMemo(() => {
  return filteredTasks.filter(task => task.project_id && task.project_id.trim() !== '');
}, [filteredTasks]);
  
        const handleStart = useCallback((task) => {
    const now = new Date().toISOString();
  
    // Check if another task is already running
    const runningTask = taskData.find(t => {
      try {
        const sessions = JSON.parse(t.duration || '[]');
        const last = sessions[sessions.length - 1];
        return last && last.start && !last.pause && !last.end;
      } catch {
        return false;
      }
    });
  
    // If another task is running and it's not the current one, block
    if (runningTask && runningTask.id !== task.id) {
      alert("Only one task can run at a time. Please pause or end the other task first.");
      return;
    }
  
    updateDuration(task.id, { start: now });
  }, [taskData, updateDuration]);
  
  
        const handlePause = useCallback((task) => {
    const now = new Date().toISOString();
  
    // Check if this task is already paused and trying to resume (unpause)
    const sessions = (() => {
      try {
        return JSON.parse(task.duration || '[]');
      } catch {
        return [];
      }
    })();
  
    const last = sessions[sessions.length - 1];
  
    const isResuming =
      last && last.start && last.pause && !last.end;
  
    if (isResuming) {
      // Check if any other task is already running
      const runningTask = taskData.find(t => {
        try {
          const s = JSON.parse(t.duration || '[]');
          const l = s[s.length - 1];
          return (
            l &&
            l.start &&
            !l.pause &&
            !l.end &&
            t.id !== task.id
          );
        } catch {
          return false;
        }
      });
  
      if (runningTask) {
        alert("Only one task can run at a time. Pause or end the other task first.");
        return;
      }
  
      // Resume by creating a new session
      updateDuration(task.id, { start: now });
      return;
    }
  
    // Otherwise, apply normal pause
    updateDuration(task.id, { pause: now });
  
  }, [taskData, updateDuration]);
  
  
        const handleEnd = useCallback((task) => {
          const now = new Date().toISOString();
          updateDuration(task.id, { end: now });
        }, [updateDuration]);
  
        useEffect(() => {
          axios.get('/api/mainuser.php?action=tasks', { withCredentials: true })
          .then(res => {setTaskData(res.data);})
          .catch(err => console.error('Fetch error:', err));
  
        }, []);
  
  
       
  
        const columns = useMemo(() => [
  
          {
            Header: "Project Name",
            accessor: "project_id", // still use project_id to map
            Cell: ({ value }) => (
              <span title={value} className="inline-block max-w-40 whitespace-normal break-words">
                {projectNames[value] || ''}
              </span>
            )
          },
          { Header: "Task ID", accessor: "task_id" },
          { Header: "Task Name", accessor: "task_name",
            Cell:({value}) =>(
              <span className="inline-block w-40 whitespace-normal break-words">{value}</span>
            )
           },
           { Header: "Client", accessor: "client_name" },
           { Header: "Assign By", accessor: "assign_by" },
           
          {
            Header: "",
            accessor: "comment",
            Cell: ({ row }) => {
              let commentArray = [];
              const rawComment = row.original.comment;
  
              if (typeof rawComment === 'string') {
                try {
                  const parsed = JSON.parse(rawComment);
                  commentArray = Array.isArray(parsed) ? parsed : [parsed];
                } catch {
                  commentArray = rawComment ? [rawComment] : [];
                }
              } else if (Array.isArray(rawComment)) {
                commentArray = rawComment;
              } else if (rawComment) {
                commentArray = [rawComment];
              }
              const commentCount = commentArray.length;
              return (
                <div className="">
                  <button className="relative">
                    <FontAwesomeIcon icon={faComment} />
                    {commentCount > 0 && (
                      <span className="absolute bottom-4 left-3 bg-gray-600 text-white rounded-full text-[0.45rem] px-1">
                        {commentCount}
                      </span>
                    )}
                  </button>
                </div>
              );
            },
          },
          {
            Header: "Priority",
            accessor: "priority",
            Cell: ({ value }) => {
              let bgColor = "transparent";
              let textColor = "inherit";
              if (value === "Medium") {
                bgColor = "#d1fae5"; // green-100
              } else if (value === "Urgent") {
                bgColor = "#f87171"; // red-400
                textColor = "white";
              }
                return (
                  <div
                    style={{
                      fontSize: '12px',
                      textAlign: 'center',
                      borderRadius: '10px',
                      backgroundColor: bgColor,
                      color: textColor,
                    }}
                  >
                    {value}
                  </div>
                );
            }
          },
          {
            Header: "Start Date",
            accessor: "start_date",
            Cell: ({ value }) => {
              if (!value) return "";
              const date = new Date(value);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }
          },
          {
            Header: "Tentative Time",
            accessor: "submission_date",
            Cell: ({ value }) => value ? `${value} hr ` : '',  // Custom display
          },
          {
            Header: "Submission Date",
            accessor: "due_date",
            Cell: ({ value }) => {
              if (!value) return "";
              const date = new Date(value);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }
          },
          {
  Header: "Action",
  accessor: "duration",
  Cell: ({ row }) => {
    const task = row.original;
    const hasProject = task.project_id && task.project_id.trim() !== "";

    return (
      <div className="flex items-center gap-2 justify-between">
        <TaskTimerAction
          task={task}
          onStart={handleStart}
          onPause={handlePause}
          onEnd={handleEnd}
        />
        <div className="flex gap-1">
        {!hasProject && (
          
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(task.id);
              }}
              className="text-gray-600 hover:text-green-800 mr-1"
            >
              <FontAwesomeIcon icon={faPenToSquare} />
            </button>
            )}
            <button
              onClick={(e) => {
                e.stopPropagation();
                deleteTask(task.id);
              }}
              className="text-gray-600 hover:text-red-800 mr-4"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        
      </div>
    );
  }
}, ], [handleStart, handlePause, handleEnd, projectNames]);
  
        
  const filteredColumns = useMemo(() => {
  if (activeTab === 'Task') {
    return columns.filter(
      col => col.accessor !== 'assign_by' 
    );
  }
  return columns;
}, [activeTab, columns]);
      
       // Task Table
  const {
  getTableProps, getTableBodyProps, headerGroups, prepareRow, page,
  state, nextPage, previousPage, canNextPage, canPreviousPage, pageCount,
  gotoPage, pageOptions, setPageSize, setGlobalFilter
} = useTable(
  {
    columns: filteredColumns,
    data: activeTab === 'Task' ? filteredProjectTasks : filteredIndividualTasks,
    initialState: { pageIndex: 0, pageSize: 20 }
  },
  useGlobalFilter,
  usePagination
);

  

  
  // Individual Task Table
  const {
    state: individualState,
  canNextPage: individualCanNextPage,
  canPreviousPage: individualCanPreviousPage,
  nextPage: individualNextPage,
  previousPage: individualPreviousPage,
  pageCount: individualPageCount,
  gotoPage: individualGotoPage,
  pageOptions: individualPageOptions,
  setPageSize: setIndividualPageSize,
    getTableProps: getIndividualTableProps,
    getTableBodyProps: getIndividualTableBodyProps,
    headerGroups: individualHeaderGroups,
    prepareRow: prepareIndividualRow,
    page: individualPage,
    setGlobalFilter: setIndividualGlobalFilter,
  } = useTable(
    {
      columns,
      data: filteredIndividualTasks,
      initialState: { pageIndex: 0, pageSize: 20 },
    },
    useGlobalFilter,
    usePagination
  );
  
  
        const { pageIndex, pageSize } = state;
  
        return (
          <div className="container-dash  pt-5 px-6 h-200">
            <div className="d-flex justify-content-center mb-6">
              <div className="search shadow-xl">
                <input
                  className="search_input"
                  type="text"
                  placeholder="Search here..."
                  value={filterInput}
                  onChange={e => {
                    setFilterInput(e.target.value);
                    if (activeTab === 'Task') {
                      setGlobalFilter(e.target.value);
                    } else {
                      setIndividualGlobalFilter(e.target.value);
                    }
                  }}
                />
                <a href="#/" className="search_icon" onClick={e => e.preventDefault()}>
                  <i className="fa fa-search"></i>
                </a>
              </div>
            </div>
            <div className='flex text-right  mr-3 font-semibold text-gray-500 justify-between'>
              <div className="flex space-x-4 mb-4">
                <button
                  onClick={() => setActiveTab('singletask')}
                  className={`p-4 pt-1 pb-1  shadow-xl rounded ${activeTab === 'singletask' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700 '}`}
                >
                  🎯 Single Tasks
                </button>
                <button
                  onClick={() => setActiveTab('Task')}
                  className={`p-4 pt-1 pb-1 rounded shadow-xl ${activeTab === 'Task' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700 '}`}
                >
                  📋 Project Tasks
                </button>
                
              </div>
              <div>
                <button
                  onClick={() => setShowPopup(true)}
                  className='bg-white p-4 pt-1 pb-1 rounded shadow-xl'
                >
                  <span className='text-red-400 text-lg'>+</span> Add 
                </button>
              </div>
            </div>
        {activeTab === 'Task' ? (
          <>
            {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
              {/* Task Table Here */}
              <div className="overflow-x-auto bg-white rounded shadow w-full shadow-xl overflow-y-auto max-h-150 scrollbar-hide">
  <table {...getTableProps()} className="min-w-full divide-y divide-gray-200">
    {/* Table Headers */}
    <thead className="bg-gray-700 sticky top-0 z-0">
      {headerGroups.map(headerGroup => {
        const { key: headerKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
        return (
          <tr key={headerKey} {...headerGroupProps}>
            {headerGroup.headers.map(column => {
              const { key: columnKey, ...columnProps } = column.getHeaderProps();
              return (
                <th
                  key={columnKey}
                  {...columnProps}
                  className="px-2 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
                >
                  {column.render("Header")}
                </th>
              );
            })}
          </tr>
        );
      })}
    </thead>

    {/* Table Body */}
    <tbody {...getTableBodyProps()} className="divide-y divide-gray-200">
      {page.map(row => {
        prepareRow(row);
        const { key: rowKey, ...rowProps } = row.getRowProps();

        return (
          <tr
            key={rowKey}
            {...rowProps}
            className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
  onMouseEnter={() => setHoveredRowIndex(row.id)}
            onClick={() => {
              setSelectedRowData(row.original);
              setShowSidebar(true);
            }}
          >
            {row.cells.map(cell => {
              const { key: cellKey, ...cellProps } = cell.getCellProps();
              return (
                <td
                  key={cellKey}
                  {...cellProps}
                  className="px-2 py-3 text-[12px] text-gray-700 "
                >
                  {cell.render('Cell')}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  </table>
</div>

            {/* Slide-in Sidebar */}
        <SlideTask
          show={showSidebar}
          onClose={() => setShowSidebar(false)}
          data={selectedRowData}
        />
          </>
        ) : (
          <>
            <div className="overflow-x-auto bg-white rounded shadow w-full shadow-xl overflow-y-auto max-h-150 scrollbar-hide">
              <table {...getIndividualTableProps()} className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-700 sticky top-0 z-10">
        {individualHeaderGroups.map(headerGroup => {
          const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
          return (
            <tr key={key} {...restHeaderGroupProps}>
              {headerGroup.headers.map(column => {
                const { key, ...restColumnProps } = column.getHeaderProps();
                return (
                  <th
                    key={key}
                    {...restColumnProps}
                    className="px-2 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
                  >
                    {column.id === 'project_id' ? '\u00A0' : column.render('Header')}
                  </th>
                );
              })}
            </tr>
          );
        })}
      </thead>
  
      <tbody {...getIndividualTableBodyProps()} className="divide-y divide-gray-200">
        {individualPage.map(row => {
          prepareIndividualRow(row);
          const { key, ...restRowProps } = row.getRowProps();
          return (
            <tr
              key={key}
              {...restRowProps}
              className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
  onMouseEnter={() => setHoveredRowIndex(row.id)}
              onClick={() => {
                setSelectedRowData(row.original);
                setShowSidebar(true);
              }}
            >
              {row.cells.map(cell => {
                const { key, ...restCellProps } = cell.getCellProps();
                return (
                  <td
                    key={key}
                    {...restCellProps}
                    className="px-2 py-3 text-[12px] text-gray-700 "
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
            </div>
          {/* 👇 Sidebar for Single Task */}
          <SlideTask
            show={showSidebar}
            onClose={() => setShowSidebar(false)}
            data={selectedRowData}
          />
        </>
        )}
  
      
      {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
          {/* Pagination */}
<div className="flex items-center justify-between mt-4">
  <div className="text-sm text-gray-800 font-bold">
    Page {(activeTab === 'Task' ? pageIndex + 1 : individualState.pageIndex + 1)} of {(activeTab === 'Task' ? pageOptions.length : individualPageOptions.length)}
  </div>
  <div className="flex items-center space-x-2">
    <button
      onClick={() => (activeTab === 'Task' ? gotoPage(0) : individualGotoPage(0))}
      disabled={activeTab === 'Task' ? !canPreviousPage : !individualCanPreviousPage}
      className="p-2 text-gray-700"
    >
      <FaAngleDoubleLeft />
    </button>
    <button
      onClick={() => (activeTab === 'Task' ? previousPage() : individualPreviousPage())}
      disabled={activeTab === 'Task' ? !canPreviousPage : !individualCanPreviousPage}
      className="p-2 text-gray-700"
    >
      <FaChevronLeft />
    </button>
    <button
      onClick={() => (activeTab === 'Task' ? nextPage() : individualNextPage())}
      disabled={activeTab === 'Task' ? !canNextPage : !individualCanNextPage}
      className="p-2 text-gray-700"
    >
      <FaChevronRight />
    </button>
    <button
      onClick={() => (activeTab === 'Task' ? gotoPage(pageCount - 1) : individualGotoPage(individualPageCount - 1))}
      disabled={activeTab === 'Task' ? !canNextPage : !individualCanNextPage}
      className="p-2 text-gray-700"
    >
      <FaAngleDoubleRight />
    </button>
  </div>
  <select
    value={activeTab === 'Task' ? pageSize : individualState.pageSize}
    onChange={(e) =>
      activeTab === 'Task'
        ? setPageSize(Number(e.target.value))
        : setIndividualPageSize(Number(e.target.value))
    }
    className="p-1 rounded bg-white text-xs shadow-xl"
  >
    {[20, 50, 100].map((size) => (
      <option key={size} value={size}>
        Show {size}
      </option>
    ))}
  </select>
</div>
{/* Popup Component */}
      {isEditOpen && (
            <div className="fixed inset-0 z-40  backdrop-blur-sm transition-opacity duration-300">

        <EditTaskPopup
          taskId={editTaskId}
          onClose={() => setIsEditOpen(false)}
        />
        </div>
      )}
  
          </div>
  
          
    );
  
    
}

export default UserTaskList